<template>
    <div>
    <b-table
    ref="needsFocus"
    show-empty
    small
    :items="localItems"
    :fields="[{key: 'key', label: '', isRowHeader: true}, {key: 'value', label: ''}, {key: 'actions', label: ''}]">
        <template v-slot:cell(key)="row">
            <input
            v-model="row.item.key"
            class="form-control"
            required
            autofocus
            :class="{ 'is-invalid': !row.item.key }">
        </template>
        <template v-slot:cell(value)="row">
            <input
            v-model="row.item.value"
            class="form-control">
        </template>
        <template v-slot:head(actions)="data">
            <font-awesome-icon class="clickable" icon="plus" @click="addRow" />
        </template>
        <template v-slot:cell(actions)="row">
            <font-awesome-icon class="clickable" icon="trash-can" @click="deleteRow(row.index)" />
        </template>
    </b-table>
    <div class="float-right">
        <button class="btn btn-sm btn-outline-danger mr-1" type="button" @click="cancel()">Cancel</button>
        <button class="btn btn-sm btn-outline-success" type="button" :disabled="!isDirty || !isValid" @click="save()">Save</button>
    </div>
    </div>
</template>

<script>
export default {
    name: "extras-form",
    props: {
        items: null,
    },
    emits: [
        "close"
    ],
    data() {
        return {
            localItems: null,
            isSaving: false,
        };
    },
    mounted() {
        this.localItems = _.cloneDeep(this.items);
    },
    methods: {
        async addRow() {
            this.localItems.push({
                key: "",
                value: "",
            });
            this.$nextTick(() => {
                // Focus the first input in the last row
                let table =  this.$refs.needsFocus.$el;
                table.rows[table.rows.length - 1].firstChild.firstChild.focus();
            });
        },
        async deleteRow(index) {
            this.localItems.splice(index, 1);
        },
        async cancel() {
            this.localItems = _.cloneDeep(this.items);
            this.$emit("close");
        },
        async save() {
            this.isSaving = true;
            await this.$emit('save', this.localItems);
            this.isSaving = false;
            this.$emit("close");
        },
    },
    computed: {
        isValid() {
            const isEmpty = (value) => value === undefined || value === null || value === "";
            const hasEmptyKey = this.localItems.some((item) => (isEmpty(item.key)));
            return !hasEmptyKey;
        },
        isDirty() {
            if (this.localItems === null || this.items === null) return false;
            if (this.localItems.length !== this.items.length) return true;
            for (let i = 0; i < this.localItems.length; ++i) {
                if (this.localItems[i].key !== this.items[i].key) return true;
                if (this.localItems[i].value !== this.items[i].value) return true;
            }
            return false;
        }
    }
};
</script>
